export function calculateCumulativeInterest({loanAmount, monthlyPayment, paymentCount}: {loanAmount: number, monthlyPayment: number, paymentCount: number}) {
  return (paymentCount * monthlyPayment) - loanAmount
}